import { useLocalStorage } from '@vueuse/core';
import { computed } from 'vue';

import { browserStorageNamespacedKey } from '@/utils/browserStorage';
import { detectBrowser } from '@/utils/browserVersion';

const STORAGE_KEY = 'browser-version-warning-dismissed-at';
const RE_SHOW_AFTER_MS = 30 * 24 * 60 * 60 * 1000;

export function useBrowserVersionWarning(userAgent?: string) {
  const ua = userAgent ?? (typeof navigator === 'undefined' ? '' : navigator.userAgent);
  const browser = detectBrowser(ua);
  const dismissedAt = useLocalStorage<string | null>(
    browserStorageNamespacedKey(STORAGE_KEY),
    null,
  );

  const shouldShow = computed(() => {
    if (!browser.isOutdated) return false;
    if (!dismissedAt.value) return true;
    const dismissedTime = new Date(dismissedAt.value).getTime();
    if (Number.isNaN(dismissedTime)) return true;
    return Date.now() - dismissedTime > RE_SHOW_AFTER_MS;
  });

  function dismiss() {
    dismissedAt.value = new Date().toISOString();
  }

  return { shouldShow, dismiss, browser };
}
